import React from 'react';

export default function IndexTableFiltersPanelInput(props) {
    return (
        <div className="filters-panel-input">
            <span title={props.label}>{props.label}</span>
            <span className="filter-single-input">
                <input type="text" value={props.value}
                       onChange={e => props.onChange({text: e.target.value, value: e.target.value})}/>
            </span>
        </div>
    )
}